import { cx } from '../../utils/cx';
import styles from './BrandMark.module.css';

export interface BrandMarkProps {
  size?: number;
  /** `false` — лише птах, без темного квадрата. */
  framed?: boolean;
  className?: string;
}

// `aria-hidden`: поруч зі знаком завжди є текстова назва.
export function BrandMark({ size = 40, framed = true, className }: BrandMarkProps) {
  const bird = <span className={styles.bird} />;
  if (!framed) {
    return (
      <span
        className={cx(styles.bird, className)}
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
    );
  }
  return (
    <span
      className={cx(styles.badge, className)}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {bird}
    </span>
  );
}
